export var EColumnAggregationType;
(function (EColumnAggregationType) {
    EColumnAggregationType["Sum"] = "SUM";
    EColumnAggregationType["Avg"] = "AVG";
})(EColumnAggregationType || (EColumnAggregationType = {}));
export var EAggregationType;
(function (EAggregationType) {
    EAggregationType["Sum"] = "SUM";
    EAggregationType["Max"] = "MAX";
    EAggregationType["Min"] = "MIN";
    EAggregationType["None"] = "NONE";
    EAggregationType["Avg"] = "AVG";
    EAggregationType["TenorBucket"] = "TENOR_BUCKET";
})(EAggregationType || (EAggregationType = {}));
